import {Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UiToolsService} from '../../core/ui-tools.service';
import {SearchSelectorService} from '../../core/search-selector.service';
import {SelectorContainer} from '../../core/definitions/selector-container';
import {SearchExecutorService} from '../search-executor.service';
import {SearchTemplateGroupService} from '../search-template-group.service';
import {SearchContainer} from '../../core/definitions/search-container';

@Component({
    selector: 'app-search-header',
    templateUrl: './search-header.component.html',
    styleUrls: ['./search-header.component.scss'],
    standalone: false
})
export class SearchHeaderComponent implements OnInit, OnDestroy {
  // Injections
  private readonly searchExecutorService: SearchExecutorService = inject(SearchExecutorService);
  private readonly searchTemplateGroupService: SearchTemplateGroupService = inject(SearchTemplateGroupService);
  private readonly selectorHandler: SearchSelectorService = inject(SearchSelectorService);
  private readonly uiTools: UiToolsService = inject(UiToolsService);

  @Input() searchContainer: SearchContainer;
  @Input() searchPlaceholder: string;
  @Input() sideMenuSmallScreen;
  @Output() toggleSideMenuSmallScreen = new EventEmitter<object>();

  @Output() toggleFilterMenu = new EventEmitter<boolean>();

  newLayout = true;
  setSearchQueryFocus = false;
  mediumScreen: boolean;
  templateSelectorContainer: SelectorContainer;
  curSelectorContainer: SelectorContainer;
  private stopSizeWatch;

  ngOnInit() {
    this.mediumScreen = this.uiTools.setMediumScreenSizeOnLoad(this.mediumScreen);
    this.stopSizeWatch = this.uiTools.addWindowSizeListener(newVal => {
        if (newVal) {
          this.mediumScreen = newVal.width < 1025;
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.stopSizeWatch) {
      this.uiTools.removeWindowSizeListener(this.stopSizeWatch);
    }
  }

  toggleSideFilterMenuSmallScreen() {
    this.toggleSideMenuSmallScreen.emit();
  }

  selectorOverlay() {
    if (this.templateSelectorContainer && this.templateSelectorContainer.selectorEnabled) {
      this.selectorHandler.disableSelector(this.templateSelectorContainer);
    }
    if (this.searchContainer.selectorContainer && this.searchContainer.selectorContainer.selectorEnabled) {
      this.selectorHandler.disableSelector(this.searchContainer.selectorContainer);
    }
    if (this.searchContainer.operationContainer && this.searchContainer.operationContainer.selectorEnabled) {
      this.selectorHandler.disableSelector(this.searchContainer.operationContainer);
    }
    if (this.searchContainer.operationContainerDropDown && this.searchContainer.operationContainerDropDown.selectorEnabled) {
      this.selectorHandler.disableSelector(this.searchContainer.operationContainerDropDown);
    }
  }

  onTemplateSelectorCreated(templateSelectorContainer) {
    this.templateSelectorContainer = templateSelectorContainer;
  }

  onChangeTemplateGroup(newGroupId) {
    this.searchTemplateGroupService.setTemplateGroup(this.searchContainer, newGroupId);
    this.searchExecutorService.runSearch(this.searchContainer).then();
  }

  isSearchViewSelectorEnabled() {
    let res = this.templateSelectorContainer && this.templateSelectorContainer.selectorEnabled;
    if (res) {
      this.curSelectorContainer = this.templateSelectorContainer;
    }
    if (!res) {
      res = !!this.searchContainer.selectorContainer;
      if (res) {
        this.curSelectorContainer = this.templateSelectorContainer;
      }
    }
    if (!res) {
      res = !!this.searchContainer.operationContainer?.selectorEnabled;
      if (res) {
        this.curSelectorContainer = this.searchContainer.operationContainer;
      }
    }
    if (!res) {
      res = !!this.searchContainer.operationContainerDropDown?.selectorEnabled;
      if (res) {
        this.curSelectorContainer = this.searchContainer.operationContainerDropDown;
      }
    }
    if (!res) {
      this.curSelectorContainer = null;
    }

    if (!this.checkNewReportOpen()) {
      this.toggleFilterMenu.emit(res);
    }

    return res;
  }

  checkNewReportOpen(): boolean {
    if (this.searchContainer.operationContainer?.currentOperation?.$$currentStep?.operation_step_type === 'create_new_report') {
      this.toggleFilterMenu.emit(true);
      return true;
    }

    this.toggleFilterMenu.emit(false);
    return false;
  }
}
